import { ComponentProps } from "react"
import { Button } from "../ui/button"

type ButtonProps = ComponentProps<typeof Button>

export function SubmitButton({ children = "Submit", ...props }: ButtonProps) {
  return <Button {...props} >{children}</Button>
}
export function DeleteButton({ children = "Delete", ...props }: ButtonProps) {
  return <Button className="bg-rose-500" {...props} >{children}</Button>
}
